// Lightweight global script. Theme-scoped enhancements live in section-level
// {% javascript %} blocks. This file handles:
//   1. Routes helper exposure
//   2. Cart count refresh after AJAX add
//   3. Predictive search throttling helper
//   4. Share button (Web Share API with copy fallback)

(function () {
  'use strict';

  const routes = (window.Shopify && window.Shopify.routes) || { root: '/' };

  // 1. Cart count refresh — call after a successful cart/add.js to update header bubble.
  window.refreshCartCount = async function refreshCartCount() {
    try {
      const res = await fetch(`${routes.root}cart.js`);
      const cart = await res.json();
      document.querySelectorAll('.header__cart-count').forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (e) {
      console.warn('Cart count refresh failed', e);
    }
  };

  // 2. Add-to-cart wiring for product forms with [data-product-form]
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action$="/cart/add"]');
    if (!form || !form.querySelector('[data-product-form]')) return;
    event.preventDefault();

    const formData = new FormData(form);
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    try {
      const res = await fetch(`${routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      if (!res.ok) throw new Error(`Add failed: ${res.status}`);
      await window.refreshCartCount();
      window.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {
      console.warn('Cart add failed', e);
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  });

  // 3. Share button
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.share__button');
    if (!btn) return;
    const url = btn.dataset.shareUrl;
    const text = btn.dataset.shareText;
    if (navigator.share) {
      try { await navigator.share({ title: text, url }); } catch (_) { /* canceled */ }
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(url);
        btn.textContent = 'Copied';
        setTimeout(() => (btn.textContent = btn.dataset.label || 'Share'), 1500);
      } catch (_) { /* ignore */ }
    }
  });

  // 4. Simple slideshow autoplay
  document.querySelectorAll('.slideshow[data-autoplay="true"]').forEach((sl) => {
    const track = sl.querySelector('.slideshow__track');
    if (!track) return;
    const slides = track.children;
    let index = 0;
    const speed = parseInt(sl.dataset.speed || '5', 10) * 1000;
    setInterval(() => {
      index = (index + 1) % slides.length;
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }, speed);
  });
})();
